var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_36322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "#FCDCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.406 947.996C232.406 947.996 234.506 960.696 233.406 963.796",
    stroke: "#4E003D",
    strokeWidth: 1.0753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.008 929.597C219.008 929.597 218.008 936.397 219.308 936.697C220.508 936.997 240.308 938.197 240.308 936.397C240.308 934.597 238.808 929.297 238.808 929.297L219.008 929.597Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.808 894.498C220.808 894.498 219.008 886.798 220.808 886.198C222.608 885.598 238.708 883.998 239.908 885.898C241.108 887.698 239.308 897.698 239.308 897.698L220.808 894.498Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.905 932.999C223.905 932.999 206.006 932.499 203.706 914.299C201.206 895.699 224.905 881.799 246.905 894.699C267.906 906.999 253.405 938.299 223.905 932.999Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.209 949.598C228.209 949.598 228.009 957.398 226.109 963.598",
    stroke: "#4E003D",
    strokeWidth: 1.0753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.808 949.598C229.808 949.598 230.408 957.298 229.008 963.798",
    stroke: "#4E003D",
    strokeWidth: 1.0753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.305 948.898C231.305 948.898 232.305 956.498 231.705 963.098",
    stroke: "#4E003D",
    strokeWidth: 1.0753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.203 943.096C236.003 943.696 235.503 950.196 230.003 950.196C224.403 950.096 224.403 942.496 230.203 943.096Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.403 890.699C222.403 890.699 201.003 909.299 220.103 932.599",
    stroke: "#4E003D",
    strokeWidth: 1.0753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.008 890.699C239.008 890.699 256.308 916.999 239.208 932.499",
    stroke: "#4E003D",
    strokeWidth: 1.0753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.606 889.496L229.406 933.896",
    stroke: "#4E003D",
    strokeWidth: 1.0753,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 908.301C147.5 908.301 149.8 922.501 148.7 926.001",
    stroke: "#4E003D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.602 887.8C132.602 887.8 131.602 895.4 132.902 895.7C134.202 896 156.302 897.5 156.302 895.4C156.302 893.3 154.502 887.5 154.502 887.5L132.602 887.8Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.605 848.599C134.605 848.599 132.505 839.999 134.605 839.299C136.705 838.599 154.605 836.899 156.005 838.999C157.405 841.099 155.305 851.999 155.305 851.999L134.605 848.599Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.002 891.499C138.002 891.499 118.102 890.899 115.402 870.599C112.702 849.799 139.102 834.399 163.602 848.799C187.202 862.499 171.002 897.399 138.002 891.499Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.902 910.098C142.902 910.098 142.702 918.698 140.602 925.698",
    stroke: "#4E003D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.602 910.098C144.602 910.098 145.202 918.698 143.602 925.898",
    stroke: "#4E003D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.203 909.301C146.203 909.301 147.403 917.801 146.703 925.101",
    stroke: "#4E003D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.002 902.698C151.502 903.298 150.802 910.598 144.702 910.598C138.602 910.698 138.602 902.098 145.002 902.698Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.299 844.301C136.299 844.301 112.499 865.101 133.699 891.101",
    stroke: "#4E003D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.805 844.301C154.805 844.301 174.105 873.701 155.005 890.901",
    stroke: "#4E003D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.403 842.898L144.203 892.498",
    stroke: "#4E003D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.3 884.703C1772.3 884.703 1776.7 884.503 1776.9 879.003C1777.1 873.603 1773.3 873.703 1773.3 873.703C1773.3 873.703 1775.2 875.603 1774.7 877.303C1774.1 879.003 1771.3 880.203 1771.3 880.203L1772.3 884.703Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.4 896.502C1764.4 896.502 1777 895.202 1776 886.702C1775 878.102 1767.4 875.902 1763.8 880.102C1760.2 884.302 1765.9 889.302 1768.9 888.002C1768.9 888.002 1765.9 891.902 1764.1 890.602L1764.4 896.502Z",
    fill: "#FFAE48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.2 891.103C1765.2 891.103 1772.2 887.103 1769.8 883.303C1768 880.403 1765.4 883.403 1765.4 883.403",
    stroke: "#4E003D",
    strokeWidth: 0.816,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.8 878.503C1765.8 878.503 1774.5 875.103 1775.7 887.103",
    stroke: "#4E003D",
    strokeWidth: 0.816,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726.31 927.004C1726.31 927.004 1722.71 948.104 1723.71 954.604L1731.51 952.504L1737.71 956.304L1750.21 928.104L1726.31 927.004Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.6 947.303C1736 943.803 1728.6 944.704 1723.8 945.904C1723.5 949.404 1723.4 952.603 1723.6 954.503L1731.4 952.404L1737.6 956.204L1741.6 947.303Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.3 905.103C1683.3 905.103 1658.8 903.703 1649.6 916.703L1655.4 917.703L1654 924.803H1691.4L1683.3 905.103Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.4 924.804C1665.7 919.104 1661.8 912.604 1659.6 909.004C1655.7 910.704 1652.1 913.204 1649.6 916.604L1655.4 917.604L1654 924.704H1667.4V924.804Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.1 875.504C1751.1 875.504 1790.1 902.104 1754.8 929.704C1719.4 957.204 1650.2 930.904 1690.6 879.104L1751.1 875.504Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.1 875.504L1749.6 875.604C1743.9 883.304 1738.2 893.804 1742.4 900.104C1746.8 906.704 1758.6 911.504 1768.7 911.504C1774.4 891.504 1751.1 875.504 1751.1 875.504Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.4 882.305C1755.4 882.305 1760.1 884.505 1761.7 889.905",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.3 889.105C1758.3 889.105 1759.5 891.505 1760.1 893.005",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.99 893.004C1763.99 893.004 1764.99 895.204 1765.39 896.804",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.2 896.902C1762.2 896.902 1763.3 900.102 1763.9 902.202",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.09 900.703C1767.09 900.703 1767.59 903.703 1767.59 905.403",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.9 885.902C1750.9 885.902 1752.7 887.702 1753.9 889.402",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.2 894.504C1756.2 894.504 1758.3 897.104 1759.2 898.504",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.7 917.105C1681.7 917.105 1683.1 922.305 1685.8 923.805",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686.8 920.406C1686.8 920.406 1688.7 922.306 1689.4 923.006",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.49 937.805C1717.49 937.805 1719.89 938.805 1723.09 938.605",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724.9 935.605C1724.9 935.605 1727.9 935.405 1730.7 935.105",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.49 937.306C1731.49 937.306 1734.89 936.306 1739.09 934.906",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.49 931.606C1738.49 931.606 1743.09 930.306 1743.69 929.906",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.6 917.703C1702.6 917.703 1682.1 932.903 1684.6 950.703L1689.9 949.203L1697.7 953.803L1714.5 933.303L1702.6 917.703Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.6 950.702L1689.9 949.202L1697.7 953.802L1703.9 946.302C1699.3 942.102 1690.9 940.802 1685.7 940.402C1684.6 943.602 1684.2 947.102 1684.6 950.702Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.2 946.003C1685.2 946.003 1685.8 929.003 1702.7 917.703",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701 949.903L1714.5 933.203",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.2 922.703C1743.2 922.703 1759.4 943.703 1773.7 942.203L1774.3 938.403L1780.2 936.303L1768.4 915.903C1766.7 912.903 1763 911.903 1760 913.503L1743.2 922.703Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.6 942.204L1774.2 938.404L1780.1 936.304L1774.8 927.004C1766.7 928.804 1763.1 934.304 1761.4 939.004C1765.4 941.204 1769.6 942.704 1773.6 942.204Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.9 921.504C1741.9 921.504 1753.1 935.704 1764.6 940.304",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.3 817.203C1694.5 813.003 1680.3 814.803 1671.1 820.503C1664.7 823.803 1660.2 828.703 1657.3 835.203C1654.6 840.203 1653.1 848.303 1653.1 848.303C1620.6 872.503 1656.1 905.303 1680 908.703L1698.5 911.303C1718.7 913.103 1741.1 906.303 1747.5 882.703L1747.9 882.903C1747.8 882.803 1769.2 828.203 1715.3 817.203Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714.4 827.503C1714.4 827.503 1717.8 823.503 1722.4 825.403C1726.4 827.103 1726.6 830.003 1726.6 830.003",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684 821.901C1684 821.901 1687.4 817.901 1692 819.801C1696 821.501 1696.2 824.401 1696.2 824.401",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.8 815.102C1698.8 815.102 1721.4 815.402 1735.6 825.302",
    stroke: "#4E003D",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.8 909.902C1757.8 901.002 1752 853.802 1752 853.802C1752 853.802 1751.4 846.702 1749.1 844.102",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654 848.602C1654 848.602 1636.2 856.402 1641.1 876.802C1646.4 899.002 1675.1 907.802 1675.1 907.802C1675.1 907.802 1690.7 911.102 1697.9 909.202",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.4 857.603C1668.3 853.003 1668.8 847.103 1670.6 842.003C1673 835.403 1677.4 830.103 1682.9 830.403C1690.6 830.803 1694.1 837.903 1694.2 845.703C1694.3 851.903 1692.1 858.603 1688.1 862.603C1687 863.703 1685.9 864.303 1685.1 864.603C1681.1 866.003 1676.1 864.203 1672.1 860.203L1669.4 857.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683 830.302C1702.2 831.302 1697.7 871.102 1678.3 869.502C1659.7 868.002 1667.8 829.602 1683 830.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.7 837.902C1698.3 841.702 1691.9 867.102 1681.9 865.702C1670.2 864.202 1676.9 834.002 1687.7 837.902Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.4 857.601C1666.8 846.801 1673.2 829.901 1682.9 830.401C1696.7 831.001 1697.1 853.601 1688.1 862.601",
    stroke: "#4E003D",
    strokeWidth: 1.632,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.3 863.904C1700.1 857.004 1702.7 850.304 1703.4 848.604C1703.4 848.604 1703.4 848.604 1703.4 848.504C1703.9 847.404 1708.9 836.104 1716.5 836.404C1721.9 836.604 1725.4 840.304 1726.9 845.304C1728.1 849.104 1728.2 853.704 1727.3 858.004C1726.7 860.704 1725.9 864.204 1723.2 867.404C1722.8 867.904 1716.2 875.504 1709.5 873.304C1704.9 871.904 1703.1 866.304 1702.3 863.904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.4 841.203C1727.1 845.003 1720.6 871.203 1710.4 869.803C1698.5 868.303 1705.4 837.203 1716.4 841.203Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.6 864.803C1699.2 853.903 1706.1 835.903 1716.6 836.503C1722 836.703 1725.5 840.403 1727 845.403C1729.2 852.403 1727.7 861.703 1723.3 867.603",
    stroke: "#4E003D",
    strokeWidth: 1.632,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.7 876.802C1705.7 876.802 1722 853.702 1738.7 870.402L1705.7 876.802Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.9 868.002C1735.7 873.202 1727.3 887.902 1717.2 882.502C1707.1 877.102 1714.9 862.202 1725.9 868.002Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703.7 878.603C1703.7 878.603 1722.9 852.003 1738.6 870.403",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.1 855.203C1661.6 855.303 1679.7 857.403 1678.9 875.703L1661.1 855.203Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.1 855.203C1661.6 855.303 1679.7 857.403 1678.9 875.703",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.5 861.901C1680.1 870.001 1668.1 882.101 1659.3 873.701C1650.4 865.201 1661.8 852.701 1671.5 861.901Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 864.602C1693 864.602 1691.2 871.802 1693.5 872.802C1695.8 873.802 1697.9 866.202 1697.9 866.202C1697.9 866.202 1694.3 868.702 1693 864.602Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.3 869.902C1692.3 871.302 1692.6 872.401 1693.5 872.801C1695 873.401 1696.4 870.602 1697.2 868.402C1694.9 867.602 1693.4 868.702 1692.3 869.902Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 864.602C1693 864.602 1691.2 871.802 1693.5 872.802C1695.8 873.802 1697.9 866.202 1697.9 866.202C1697.9 866.202 1694.3 868.702 1693 864.602Z",
    stroke: "#4E003D",
    strokeWidth: 0.816,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.4 862.402C1691.4 862.402 1694.3 867.802 1689.9 874.202",
    stroke: "#4E003D",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.2 863.504C1700.2 863.504 1695.7 865.304 1697.1 875.904",
    stroke: "#4E003D",
    strokeWidth: 1.088,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.6 850.802C1706.6 851.902 1708.2 866.402 1702.3 867.402C1698.6 868.002 1689.1 866.602 1686.3 864.702C1682.2 861.902 1689 849.902 1696.6 850.802Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694.2 854.802C1696 857.602 1693.1 863.302 1689.6 862.802C1685.9 862.302 1692.3 852.002 1694.2 854.802Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.8 856.102C1702.2 856.102 1703 865.002 1699.9 865.702C1695.7 866.602 1696.8 856.102 1698.8 856.102Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.1 845.001C1757.1 845.001 1761.5 841.001 1757.5 834.401C1753.5 827.801 1750.4 827.201 1747.3 821.201C1744.3 815.201 1739.3 808.501 1731.3 811.301C1723.3 814.101 1711.5 836.601 1720.7 844.301C1730 852.001 1743.7 837.901 1746.5 840.901C1749.6 843.901 1753.8 848.601 1757.1 845.001Z",
    fill: "#FFAE48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.4 813.902C1727.4 813.902 1709.6 834.302 1720.9 844.202C1732.3 854.102 1741.1 837.002 1750.7 838.102",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.2 814.703C1688.2 814.703 1687.1 808.203 1680.6 807.903C1674.1 807.603 1669.5 810.803 1663.8 810.703C1658.1 810.603 1654.9 807.703 1650.4 814.103C1645.8 820.503 1652.9 842.003 1663.8 838.803C1674.8 835.603 1674.5 825.303 1678.5 820.503C1681.5 816.703 1689.5 819.003 1688.2 814.703Z",
    fill: "#FFAE48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679 814.703C1679 814.703 1675.5 837.303 1663.7 838.803C1652 840.203 1647.1 823.803 1649.8 815.703",
    stroke: "#4E003D",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.3 849.703C1747.3 849.703 1748.4 853.503 1748.1 858.703",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.8 869.902C1748.8 869.902 1746.1 876.102 1745.5 878.002",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1746.6 863.703L1745.8 868.303",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.3 885.102C1742.3 885.102 1740.2 888.402 1738.9 890.102",
    stroke: "#FFAE48",
    strokeWidth: 1.632,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.2 824.301C1652.2 824.301 1653.4 829.901 1656.4 832.101",
    stroke: "#FF802C",
    strokeWidth: 1.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.2 829.602C1658.2 829.602 1659.5 833.102 1661.1 834.202",
    stroke: "#FF802C",
    strokeWidth: 1.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.9 843.901C1731.9 843.901 1736.5 842.901 1739 840.301",
    stroke: "#FF802C",
    strokeWidth: 1.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.2 837.402L1744.1 834.402",
    stroke: "#FF802C",
    strokeWidth: 1.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.1 842.001C1727.1 842.001 1730.4 841.401 1732.8 840.301",
    stroke: "#FF802C",
    strokeWidth: 1.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 796.101C1630 796.101 1631.7 794.201 1633.4 793.601C1635.2 793.101 1637.2 795.801 1637.2 795.801C1637.2 795.801 1635.7 797.501 1634.1 798.101C1632.5 798.701 1630 796.101 1630 796.101Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.51 797.301C1629.51 797.301 1632.51 798.001 1632.91 799.901C1633.41 801.801 1632.11 803.101 1632.11 803.101C1632.11 803.101 1629.91 803.201 1629.21 801.301C1628.61 799.301 1629.51 797.301 1629.51 797.301Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.6 796.499C1628.6 796.499 1627.3 796.199 1625.8 796.699C1624.3 797.199 1623.7 800.199 1623.7 800.199C1623.7 800.199 1625.9 800.899 1627.3 800.399C1628.8 799.899 1628.6 796.499 1628.6 796.499Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.6 795.402C1628.6 795.402 1626.8 796.502 1624.9 795.002C1623 793.502 1623.1 791.202 1623.1 791.202C1623.1 791.202 1624.8 791.002 1626.4 791.402C1628 791.802 1628.6 795.402 1628.6 795.402Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.6 794.701C1629.6 794.701 1627.8 792.201 1628.4 790.901C1629 789.501 1632.1 788.301 1632.1 788.301C1632.1 788.301 1633.9 790.501 1633.3 792.201C1632.6 793.901 1629.6 794.701 1629.6 794.701Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.3 903.601C1797.3 903.601 1799 901.701 1800.7 901.101C1802.5 900.601 1804.5 903.301 1804.5 903.301C1804.5 903.301 1803 905.001 1801.4 905.601C1799.8 906.201 1797.3 903.601 1797.3 903.601Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.81 904.699C1796.81 904.699 1799.81 905.399 1800.21 907.299C1800.71 909.199 1799.41 910.499 1799.41 910.499C1799.41 910.499 1797.21 910.599 1796.51 908.699C1795.81 906.799 1796.81 904.699 1796.81 904.699Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.81 903.999C1795.81 903.999 1794.51 903.699 1793.01 904.199C1791.51 904.699 1790.91 907.699 1790.91 907.699C1790.91 907.699 1793.11 908.399 1794.51 907.899C1796.11 907.399 1795.81 903.999 1795.81 903.999Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.91 902.801C1795.91 902.801 1794.11 903.901 1792.21 902.401C1790.41 900.901 1790.41 898.601 1790.41 898.601C1790.41 898.601 1792.11 898.401 1793.71 898.801C1795.41 899.201 1795.91 902.801 1795.91 902.801Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.91 902.099C1796.91 902.099 1795.11 899.599 1795.71 898.299C1796.31 896.899 1799.41 895.699 1799.41 895.699C1799.41 895.699 1801.21 897.899 1800.61 899.599C1799.91 901.499 1796.91 902.099 1796.91 902.099Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.5 935.898C1643.5 935.898 1641.8 937.798 1640.1 938.298C1638.4 938.798 1636.3 936.098 1636.3 936.098C1636.3 936.098 1637.8 934.398 1639.5 933.898C1641.2 933.298 1643.5 935.898 1643.5 935.898Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.01 934.699C1644.01 934.699 1641.01 933.999 1640.61 931.999C1640.11 930.099 1641.41 928.899 1641.41 928.899C1641.41 928.899 1643.61 928.799 1644.31 930.799C1645.01 932.699 1644.01 934.699 1644.01 934.699Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 935.498C1645 935.498 1646.3 935.798 1647.8 935.298C1649.3 934.798 1649.9 931.798 1649.9 931.798C1649.9 931.798 1647.7 930.998 1646.3 931.598C1644.8 932.198 1645 935.498 1645 935.498Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.91 936.698C1644.91 936.698 1646.71 935.597 1648.61 937.097C1650.51 938.597 1650.41 940.898 1650.41 940.898C1650.41 940.898 1648.71 940.997 1647.11 940.597C1645.41 940.297 1644.91 936.698 1644.91 936.698Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.91 937.398C1643.91 937.398 1645.61 939.898 1645.01 941.198C1644.41 942.598 1641.21 943.698 1641.21 943.698C1641.21 943.698 1639.41 941.498 1640.11 939.698C1640.91 937.998 1643.91 937.398 1643.91 937.398Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.7 803.8C1758.7 803.8 1757.5 805.2 1756.1 805.6C1754.8 806 1753.3 803.9 1753.3 803.9C1753.3 803.9 1754.4 802.6 1755.6 802.2C1757 801.9 1758.7 803.8 1758.7 803.8Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.01 802.902C1759.01 802.902 1756.81 802.302 1756.51 800.902C1756.21 799.502 1757.11 798.602 1757.11 798.602C1757.11 798.602 1758.71 798.602 1759.21 800.002C1759.81 801.502 1759.01 802.902 1759.01 802.902Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.81 803.501C1759.81 803.501 1760.71 803.701 1761.81 803.301C1762.91 802.901 1763.31 800.701 1763.31 800.701C1763.31 800.701 1761.71 800.101 1760.71 800.501C1759.71 801.101 1759.81 803.501 1759.81 803.501Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.7 804.3C1759.7 804.3 1761.1 803.5 1762.3 804.6C1763.7 805.7 1763.6 807.401 1763.6 807.401C1763.6 807.401 1762.3 807.5 1761.2 807.2C1760.1 807 1759.7 804.3 1759.7 804.3Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759 804.902C1759 804.902 1760.3 806.702 1759.9 807.702C1759.5 808.702 1757.2 809.502 1757.2 809.502C1757.2 809.502 1755.8 807.902 1756.3 806.602C1756.8 805.402 1759 804.902 1759 804.902Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.8 793V798.3",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.2 795.602H1696.5",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.51 833.301V837.401",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.41 835.402H1641.51",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.61 840.102V844.202",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.51 842.203H1773.61",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703.01 959.801V963.901",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.91 961.902H1705.01",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.51 945.5V949.7",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.51 947.602H1758.61",
    stroke: "#FFAE48",
    strokeWidth: 1.088,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_36322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage22);
export default __webpack_public_path__ + "static/media/image22.811a98c8ceaec6261a29539f6fc9b1ff.svg";
export { ForwardRef as ReactComponent };